import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  public readonly isProcessSwitchAccount: WritableSignal<boolean> = signal<boolean>(false);

  private readonly _bannersReloadRequested = new Subject<void>();
  get bannersReloadRequested$() {
    return this._bannersReloadRequested.asObservable();
  }
  triggerBannersReload(): void {
    this._bannersReloadRequested.next();
  }
}
